<script>
import { mapActions, mapGetters } from 'vuex';
import ListItem from './components/ListItem';
import SaveDialog from './components/SaveDialog';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'kullanicilar',
  components: {
    ListItem,
    SaveDialog
  },
  mixins: [snackbarMixin],
  data() {
    return {
      hasError: false,
      isInitialized: false,
      isLoading: false,
      isSaving: false,
      itemList: [],
      saveDialogData: {
        item: {},
        visible: false,
        isCreateMode: false,
      },
      sortBy: 'Id',
      descending: true,
      search: '',
    };
  },
  computed: {
    ...mapGetters('kullanicilar', ['listHeaders']),
  },
  mounted() {
    this.initializeData();
  },
  methods: {
    ...mapActions('kullanicilar', ['getList', 'delete', 'reset', 'save']),
    ...mapActions('app', ['showOverlay', 'hideOverlay']),
    fetchData() {
      this.isLoading = true;
      this.getList()
        .then((data) => {
          this.itemList = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getList()])
        .then(([result]) => {
          this.itemList = result.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    deleteRecord(id){	
      this.isLoading = true;
      this.showOverlay();	
      this.delete(id)	
        .then(() => {	
          this.showSuccessMessage(`${id} mail adresli kullanıcı silinmiştir.`);	
          this.fetchData();	
        })	
        .catch((err) => {	
          this.showErrorMessage(err.response && err.response.data);	
        })	
        .finally(() => {	
          this.isDeleting = false;	
          this.hideOverlay();
        });	
    },	
    resetRecord(id) {	
      this.reset(id).then(() => {	
          this.showSuccessMessage(`${id} kullanıcısının şifre sıfırlama isteği alınmıştır.`);	
          this.fetchData();	
        });
    },
    save(id) {
      this.isDeleting = true;
      this.showOverlay();
    },
    openSaveDialog(data) {
      this.saveDialogData.item = data;
      this.saveDialogData.visible = true;
    },
    closeSaveDialog() {
      this.saveDialogData.visible = false;
    },
    customFilter(value, search, item) {
      // eslint-disable-next-line eqeqeq
      if (!search || search == '') {
        return true;
      }

      const searchStr = search.toString().toLowerCase().trim();

      return !!(
        // eslint-disable-next-line eqeqeq
        item.Id == searchStr
        || item.name.toString().toLowerCase().trim().includes(searchStr)
        || item.surname.toString().toLowerCase().trim().includes(searchStr)
        || item.email.toString().toLowerCase().trim().includes(searchStr)
      );
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasError">
      <p class="js-error-template ma-3">
        Kullanıcı listesinde bir hata oluştu. Lütfen tekrar deneyin!
      </p>
    </template>

    <template v-else>
      <v-toolbar dark dense color="#9FA8A3">
        <b> Kullanıcı Listesi </b>
        <v-spacer />
      </v-toolbar>

      <v-card>
        <v-card-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="listHeaders"
          :items="itemList"
          :sort-by.sync="sortBy"
          :sort-desc.sync="descending"
          :search="search"
          :custom-filter="customFilter"
          class="elevation-1 spec-table"
          item-key="Id"
        >
          <template v-slot:top>
            <v-btn @click="openSaveDialog()" color="darken-3" fat text>
              Yeni Ekle
              <v-icon color="success">
                mdi-add
              </v-icon>
            </v-btn>
          </template>
          <template slot="item" slot-scope="props">
            <list-item
              :item="props.item"
              @deleteRecord="deleteRecord(props.item.email)"	
              @resetRecord="resetRecord(props.item.email)"
            />
          </template>
        </v-data-table>
      </v-card>
    </template>

    <save-dialog
      v-if="saveDialogData.visible"
      @refresh="fetchData"
      @close="closeSaveDialog"
      :item="saveDialogData.item"
      :is-create-mode="saveDialogData.isCreateMode"
    />
  </div>
</template>
